import { observable, runInAction } from 'mobx';
import ErrorUtil from '../error/ErrorUtil';
import API from '../util/ApiUtil';
import LanguageStore from './LanguageStore';
import RootStore from './RootStore';

export interface Programme {
  id: number;
  time: string;
  title: string;
  originalTitle: string;
  season: number;
  episode: number;
  description: string;
}

class GuideStore {
  @observable
  accessor statusByLanguageChannelId: {
    [language: string]: {
      [channelId: string]: 'UNINITIALIZED' | 'FETCHING' | 'FETCHED';
    };
  } = {
    et: {},
    en: {},
    ru: {}
  };
  @observable
  accessor programmesByLanguageChannelId: {
    [language: string]: { [channelId: string]: Programme[] };
  } = {
    et: {},
    en: {},
    ru: {}
  };
  private languageStore: LanguageStore;

  constructor(rootStore: RootStore) {
    this.languageStore = rootStore.languageStore;
  }

  public getStatus(channelId: string) {
    const language = this.languageStore.currentLanguage;
    return this.statusByLanguageChannelId[language][channelId] || 'UNINITIALIZED';
  }

  public getProgrammes(channelId: string) {
    const language = this.languageStore.currentLanguage;
    return this.programmesByLanguageChannelId[language][channelId] || [];
  }

  public async fetchGuideByChannelId(channelId: string) {
    const language = this.languageStore.currentLanguage;
    if (this.getStatus(channelId) !== 'FETCHED') {
      try {
        runInAction(() => {
          this.statusByLanguageChannelId[language][channelId] = 'FETCHING';
        });
        const response = await API.get(`guides/by-channel/${channelId}`, { params: { language } });
        runInAction(() => {
          this.programmesByLanguageChannelId[language][channelId] = response.data;
          this.statusByLanguageChannelId[language][channelId] = 'FETCHED';
        });
      } catch (e) {
        runInAction(() => {
          ErrorUtil.pushErrorToTeliaRumAndLog(e as Error);
          this.statusByLanguageChannelId[language][channelId] = 'UNINITIALIZED';
        });
      }
    }
  }
}

export default GuideStore;
